module.exports = __webpack_public_path__ + "img/92123.9ddcb3c0.svg";